'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import { Component } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Logo } from 'foundations-components/transitional/components/Logo';
import * as emailClients from 'InboxConnectUtils/constants/EmailClients';
import { ICON_UNKNOWN_INBOX } from 'InboxConnectUtils/constants/Images';
import StepInterface from './StepInterface';
import { OPT_INTO_AUTOMATION_STEP, CHOOSE_PROVIDER_STEP, CONNECT_INBOX_STEP } from 'InboxConnectUtils/constants/InboxConnectStepKeys';
import { ConnectProviderButton, ConnectProviderButtonTitle, ConnectProviderButtonImage } from '../button/ConnectProviderButton';
import { ConnectProviderButtonWrapper } from '../button/ConnectButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.wizard.chooseProvider.';
export default class ChooseProviderStep extends Component {
  constructor(props) {
    super(props);
    this.handleNotSureWhichToChooseLinkClick = this.handleNotSureWhichToChooseLinkClick.bind(this);
  }
  componentDidMount() {
    this.props.trackingClient.trackStepView(CHOOSE_PROVIDER_STEP);
  }
  handleClientClick(client) {
    this.props.trackingClient.trackStepAction(CHOOSE_PROVIDER_STEP, client);
    const {
      setSelectedClient,
      setShownStep,
      isAllowCustomEmailInput
    } = this.props;
    setSelectedClient(client);
    if (isAllowCustomEmailInput) {
      return setShownStep(CONNECT_INBOX_STEP);
    } else {
      return setShownStep(OPT_INTO_AUTOMATION_STEP);
    }
  }
  handleNotSureWhichToChooseLinkClick() {
    this.props.trackingClient.trackStepAction(CHOOSE_PROVIDER_STEP, 'not sure what to choose click');
  }
  renderClientButton(client, logo) {
    const {
      allowedProviders
    } = this.props;
    if (allowedProviders && !allowedProviders.includes(client)) {
      return null;
    }
    const onClick = () => this.handleClientClick(client);
    return /*#__PURE__*/_jsxs(ConnectProviderButton, {
      onClick: onClick,
      "data-selenium": `choose-provider-step-btn-${client}`,
      "data-test-id": `choose-provider-step-btn-${client}`,
      children: [logo ? /*#__PURE__*/_jsx(Logo, {
        name: logo,
        blockSize: "40px"
      }) : /*#__PURE__*/_jsx(ConnectProviderButtonImage, {
        src: ICON_UNKNOWN_INBOX,
        blockSize: "40px"
      }), /*#__PURE__*/_jsx(ConnectProviderButtonTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}${client}`
        })
      })]
    }, client);
  }
  render() {
    const {
      gmail,
      imap,
      outlook365,
      exchange
    } = emailClients;
    const {
      selectedClient,
      isAutodetectFlow
    } = this.props;
    return /*#__PURE__*/_jsx(Flex, {
      justify: "center",
      "data-selenium": "choose-provider-step",
      children: /*#__PURE__*/_jsxs(View, {
        textAlign: "center",
        children: [!selectedClient && isAutodetectFlow && /*#__PURE__*/_jsx(Alert, {
          titleText: text(`${LANG_ROUTE}errorTitle`),
          type: "info",
          marginBlockEnd: "400",
          marginInline: "auto",
          inlineSize: "50%",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}errorMsg`
          })
        }), /*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}title`
          })
        }), /*#__PURE__*/_jsx(View, {
          marginBlock: "1200",
          children: /*#__PURE__*/_jsx(ConnectProviderButtonWrapper, {
            justify: "center",
            children: [gmail, outlook365, exchange, imap].map(provider => this.renderClientButton(provider.key, provider.logo))
          })
        }), /*#__PURE__*/_jsx(Link, {
          display: "inline-block",
          external: true,
          href: "https://knowledge.hubspot.com/articles/kcs_article/email-tracking/connect-your-inbox-to-hubspot",
          onClick: this.handleNotSureWhichToChooseLinkClick,
          target: "_blank",
          use: "blue",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}link`
          })
        })]
      })
    });
  }
}
ChooseProviderStep.propTypes = StepInterface;